module.exports = __webpack_public_path__ + "static/media/img3.372571d9.jpg";